import { get } from 'lodash';
import React from 'react';

const SpotlightSvgComp = ({
	width,
	height,
	spotlights,
	id,
}: {
	width: number;
	height: number;
	spotlights: unknown[];
	id?: string;
}) => {
	if (!spotlights.length) return null;
	return (
		<svg viewBox={`0 0 ${width} ${height}`}>
			<mask id={`floik_spotlight_${id}`} maskUnits="objectBoundingBox">
				<rect x="0" y="0" width="100%" height="100%" fill="white" />
				{spotlights.map((spotlight, index) => {
					if (get(spotlight, 'shape') === 'circle') {
						const radius = get(spotlight, 'points.width', 0) / 2;
						return (
							<circle
								cx={get(spotlight, 'points.left', 0) + radius}
								r={radius}
								cy={get(spotlight, 'points.top', 0) + radius}
								strokeDasharray="4 4"
							></circle>
						);
					}
					return (
						<rect
							x={get(spotlight, 'points.left')}
							y={get(spotlight, 'points.top')}
							width={get(spotlight, 'points.width')}
							height={get(spotlight, 'points.height')}
							strokeDasharray="4 4"
							rx={6}
							ry={6}
						></rect>
					);
				})}
			</mask>
			<rect
				x="0"
				y="0"
				width="100%"
				height="100%"
				fill="rgba(0,0,0,0.5)"
				style={{ mask: `url(#floik_spotlight_${id})` }}
			/>
		</svg>
	);
};

const SpotlightSvg = React.memo(SpotlightSvgComp);

export default SpotlightSvg;
